import { getMostHighlightedTexts } from './models';

import { MostHighlightedStatement as MostHighlightedStatementFeature } from '@/features/NewLanding';

const MostHighlightedStatement = () => {
  const mostHighlightedTextsPromise = getMostHighlightedTexts();

  return (
    <MostHighlightedStatementFeature
      mostHighlightedTextsPromise={mostHighlightedTextsPromise}
    />
  );
};

export default MostHighlightedStatement;
